import { Calendar } from '@uikit/icons/Calendar';
import { Cup } from '@uikit/icons/Cup';
import { DollarCoin } from '@uikit/icons/DollarCoin';

export const STATBULL_STORY_URLS = {
  campaign: 'https://zealy.io/cw/stabull-road-to-ido-magic-square',
};

export const stats = [
  {
    name: 'Prize Pool',
    stat: '$200,000 worth of $STABUL tokens',
    Icon: Cup,
  },
  {
    name: 'Campaign Start',
    stat: '1st of October',
    Icon: Calendar,
  },
  {
    name: 'Reward Vesting',
    stat: '30% at TGE, 2-month cliff, and 9-month vesting thereafter',
    Icon: DollarCoin,
  },
];

export const investors = [
  {
    name: 'BLACK GREEN CAPITAL',
    image: {
      url: '/store/stories/stabull/black-green-capital.png',
    },
  },
  {
    name: 'CUBE ENTERTAINMENT',
    image: {
      url: '/store/stories/stabull/sixtysix-capital.png',
    },
  },
  {
    name: 'SPARKLE VENTURES',
    image: {
      url: '/store/stories/stabull/techemy-capital.png',
    },
  },
  {
    name: 'IBC',
    image: {
      url: '/store/stories/stabull/algodlo.png',
    },
  },
  {
    name: 'IBC',
    image: {
      url: '/store/stories/stabull/titanblock.png',
    },
  },
  {
    name: 'IBC',
    image: {
      url: '/store/stories/stabull/type3capital.png',
    },
  },
];
